import { WEATHERCHECKED } from "../../actions/portal/";

export default function(state = false, action) {
  switch (action.type) {
    case WEATHERCHECKED:
      return action.payload;
    default:
  }
  return state;
}
